import { TXTColors, UTColors, GraphColors } from './Colors';
import { LegacyColors } from './LegacyColors';

export const Colors = {
  ...LegacyColors,
  ut: {
    ...UTColors
  },
  text: {
    ...TXTColors
  },
  graph: {
    ...GraphColors
  }
};
